(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function safeNumber(n) {
    var x = Number(n);
    return isFinite(x) ? x : 0;
  }

  function getCurrency() {
    return (window.AVG_TRACKING && window.AVG_TRACKING.currency) ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'USD';
  }

  function pushToDataLayer(payload) {
    try { window.dataLayer.push(payload); } catch (e) {}
  }

  function pushEcomEvent(eventName, ecommerce, callback) {
    var payload = { event: eventName, ecommerce: ecommerce || {} };
    if (typeof callback === 'function') {
      payload.eventCallback = callback;
      payload.eventTimeout = 800;
    }
    pushToDataLayer(payload);
  }

  function normalizeItemFromVariant(variant, quantity) {
    if (!variant) return null;

    var itemId = variant.sku || variant.id;
    var price = safeNumber(variant.price) / 100; // cents -> currency

    return {
      item_id: String(itemId),
      item_name: variant.name || variant.product_title || undefined,
      item_brand: variant.vendor || undefined,
      item_category: variant.product_type || undefined,
      item_variant: variant.public_title || variant.title || undefined,
      price: price,
      quantity: safeNumber(quantity || 1)
    };
  }

  // view_item (product page)
  function fireViewItemOnce() {
    if (window.__avg_view_item_sent) return;
    var t = window.AVG_TRACKING && window.AVG_TRACKING.product;
    if (!t) return;

    window.__avg_view_item_sent = true;

    pushEcomEvent('view_item', {
      currency: getCurrency(),
      value: safeNumber(t.price),
      items: [{
        item_id: String(t.item_id),
        item_name: t.item_name,
        item_brand: t.item_brand,
        item_category: t.item_category,
        item_variant: String(t.variant_id),
        price: safeNumber(t.price),
        quantity: 1
      }]
    });
  }

  // add_to_cart (Ajax cart via theme.js CustomEvent)
  document.addEventListener('product:added', function (e) {
    try {
      var detail = (e && e.detail) ? e.detail : {};
      var variant = detail.variant;
      var qty = detail.quantity || 1;

      var item = normalizeItemFromVariant(variant, qty);
      if (!item) return;

      // Enrich from Liquid context when available
      if (window.AVG_TRACKING && window.AVG_TRACKING.product) {
        item.item_name = item.item_name || window.AVG_TRACKING.product.item_name;
        item.item_brand = item.item_brand || window.AVG_TRACKING.product.item_brand;
        item.item_category = item.item_category || window.AVG_TRACKING.product.item_category;
      }

      pushEcomEvent('add_to_cart', {
        currency: getCurrency(),
        value: safeNumber(item.price) * safeNumber(item.quantity),
        items: [item]
      });
    } catch (err) {}
  });

  // begin_checkout (intercept checkout submit for reliable firing)
  var checkoutInFlight = false;

  function cartToEcommerce(cart) {
    if (!cart) return null;

    var items = [];
    if (Array.isArray(cart.items)) {
      cart.items.forEach(function (it) {
        if (!it) return;
        var price = it.final_price != null ? safeNumber(it.final_price) / 100 :
          it.price != null ? safeNumber(it.price) / 100 :
          safeNumber(it.price);

        items.push({
          item_id: String(it.sku || it.variant_id || it.id || it.key),
          item_name: it.item_name || it.title || (it.product && it.product.title) || undefined,
          item_brand: it.item_brand || it.vendor || (it.product && it.product.vendor) || undefined,
          item_category: it.item_category || it.product_type || (it.product && it.product.type) || undefined,
          item_variant: String(it.variant_id || it.id || ''),
          price: price,
          quantity: safeNumber(it.quantity || 1)
        });
      });
    }

    var value = cart.total_price != null ? safeNumber(cart.total_price) : safeNumber(cart.total_price);
    // if value looks like cents, convert
    if (value > 1000) value = value / 100;

    return { currency: getCurrency(), value: safeNumber(value), items: items };
  }

  function fetchCartJs(timeoutMs) {
    timeoutMs = timeoutMs || 650;
    return new Promise(function (resolve) {
      var done = false;
      var t = setTimeout(function () { if (!done) { done = true; resolve(null); } }, timeoutMs);

      var base = (window.routes && window.routes.cartUrl) ? window.routes.cartUrl : '/cart';
      fetch(base + '.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (done) return;
          done = true; clearTimeout(t); resolve(data);
        })
        .catch(function () {
          if (done) return;
          done = true; clearTimeout(t); resolve(null);
        });
    });
  }

  function handleCheckoutSubmit(form) {
    if (checkoutInFlight) return;
    checkoutInFlight = true;

    var liquidCart = window.AVG_TRACKING && window.AVG_TRACKING.cart;
    var proceed = function () {
      try { form.submit(); } catch (e) {}
      setTimeout(function () { checkoutInFlight = false; }, 1500);
    };

    var send = function (cartData) {
      var ecommerce = cartToEcommerce(cartData);
      if (!ecommerce || !ecommerce.items || !ecommerce.items.length) {
        ecommerce = { currency: getCurrency(), value: 0, items: [] };
      }

      var fallbackTimer = setTimeout(proceed, 900);
      pushEcomEvent('begin_checkout', ecommerce, function () {
        clearTimeout(fallbackTimer);
        proceed();
      });
    };

    if (liquidCart && liquidCart.items && liquidCart.items.length) {
      send(liquidCart);
    } else {
      fetchCartJs(650).then(function (cartJs) {
        send(cartJs || liquidCart || null);
      });
    }
  }

  function bindBeginCheckout() {
    var forms = document.querySelectorAll('form[action*="/cart"]');
    forms.forEach(function (form) {
      if (form.__avg_bound_checkout) return;

      var hasCheckout = !!form.querySelector('button[name="checkout"], input[name="checkout"]');
      if (!hasCheckout) return;

      form.__avg_bound_checkout = true;

      form.addEventListener('submit', function (ev) {
        var submitter = ev.submitter;
        var isCheckoutSubmit = !submitter || (submitter && (submitter.name === 'checkout' || submitter.getAttribute('name') === 'checkout'));
        if (!isCheckoutSubmit) return;

        ev.preventDefault();
        handleCheckoutSubmit(form);
      }, true);
    });
  }

  function init() {
    fireViewItemOnce();
    bindBeginCheckout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('theme:loading:end', function () {
    bindBeginCheckout();
  });
})();
